import templateUrl from "servicestack/ipa-files/ipa-file-container.htm";
import controller from "servicestack/ipa-files/ipa-file-container.controller";

export default {
  bindings: {
    simple: "<?",
    detailRoute: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
